// @flow
import React, { type Node } from 'react';


type Props = {
  className?: string,
  title: Node,
  disabled: true,
}

const YearItem = ({ className, title }: Props): Node => {
  return (
    <div className={className}>
      {title}
    </div>
  );
};

export default YearItem;
